module.exports = __webpack_public_path__ + "images/tidings-bom-imag-new.1788773129009.png";